export default __webpack_public_path__ + "static/media/H4003.1.b193746d.mp3";